import { render, staticRenderFns } from "./TableBlueButtonTransfer.vue?vue&type=template&id=16292fa1&scoped=true&"
import script from "./TableBlueButtonTransfer.vue?vue&type=script&lang=js&"
export * from "./TableBlueButtonTransfer.vue?vue&type=script&lang=js&"
import style0 from "./TableBlueButtonTransfer.vue?vue&type=style&index=0&id=16292fa1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16292fa1",
  null
  
)

export default component.exports